import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Unidades } from "../Unidades/models/unidades";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnidadesService {
  private api: string = '/api/unidades';
      
  constructor(private http: HttpClient){}
    
  /**
   * CORREGIDO: Cambiado a plural para que haga match exacto con tu unidad-list.ts
   */
  getUnidadesList(): Observable<Unidades[]> {
    return this.http.get<Unidades[]>(this.api);       
  }  
  
  /**
   * Envía el payload relacional limpio para persistir un nuevo vehículo.
   */
  createUnidad(unidades: Unidades): Observable<Unidades> {
    return this.http.post<Unidades>(this.api, unidades);
  }

  /**
   * Actualiza las propiedades técnicas de un vehículo existente.
   * NUEVO: Indispensable para que funcione tu componente UnidadEdit.
   */
  updateUnidad(id: number, unidades: Unidades): Observable<Unidades> {
    return this.http.put<Unidades>(`${this.api}/${id}`, unidades);
  }
  
  /**
   * Remueve un vehículo del ecosistema del taller.
   */
  deleteUnidadById(id: number): Observable<any> {
    return this.http.delete(`${this.api}/${id}`);
  }

  /**
   * Consulta el catálogo global de clientes activos.
   * CORREGIDO: Apunta de forma segura a la API central de recepciones que ya tiene este catálogo optimizado.
   */
  getClientesActivos(): Observable<any[]> {
    // Reemplaza la ruta vieja de recepciones por tu api de unidades unificada
    return this.http.get<any[]>(`${this.api}/clientes-activos`);
  }
  
}